<template>
  <div class="text-center flex gap-3">
    <CustomLink
      v-for="item in social"
      :key="item.page"
      :url="item.url"
      :aria-label="$t(item.label)"
    >
      <span
        class="text-2xl"
        :class="`iconify ${item.page}`"
      />
    </CustomLink>
  </div>
</template>

<script lang="ts">

export default defineComponent({

  data() {

    return {
      social: [
        {
          page: 'svg--youtube',
          url: 'https://www.youtube.com/channel/UCLXBm1xvD5h_KRWO1bzhrTw',
          label: 'visit-youtube',
        },
        {
          page: 'svg--facebook',
          url: 'https://www.facebook.com/expondo/',
          label: 'visit-facebook',
        },
        {
          page: 'svg--linkedin',
          url: 'https://de.linkedin.com/company/expondo',
          label: 'visit-linkedin',
        },
        {
          page: 'svg--xing',
          url: 'https://www.xing.com/pages/expondogmbh',
          label: 'visit-xing',
        },
      ],
    };
  
  },
});

</script>
